<template>
  <w-icon-wrapper
    :height='18'
    :width='24'
    icon-name='work-email-icon'
    view-box='0 0 24 18'
  >
    <path
      id='_27_E-Mail_Icon'
      d='M0,3V21H24V3ZM20.41,5l-6.13,5.57-.06.05v.01L12,12.65,9.78,10.63v-.01l-.06-.05L3.59,5ZM2,6.26l5.04,4.59L2,17.15ZM3.08,19l5.45-6.81L12,15.35l3.47-3.16L20.92,19ZM22,17.15l-5.04-6.3L22,6.26Z'
      data-name='27 E-Mail_Icon'
      fill='currentColor'
      transform='translate(0 -3)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEmail' };
</script>
